module.exports = __webpack_public_path__ + "static/img/scout1.6d1d394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/scout1.png
// module id = pq9W
// module chunks = 0